<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" static class="fixed inset-0 z-50 overflow-y-auto" @close="$emit('close')" :open="show">
            <div class="flex min-h-screen items-center justify-center pt-16 text-center sm:block sm:p-0">
                <TransitionChild
                    as="template"
                    enter="ease-out duration-300"
                    enter-from="opacity-0"
                    enter-to="opacity-100"
                    leave="ease-in duration-200"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                >
                    <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </TransitionChild>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:h-screen sm:align-middle" aria-hidden="true">&#8203;</span>
                <TransitionChild
                    as="template"
                    enter="ease-out duration-300"
                    enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leave-from="opacity-100 translate-y-0 sm:scale-100"
                    leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                    <div
                        class="relative inline-block transform overflow-hidden text-left align-middle transition-all sm:my-8 sm:w-full sm:max-w-4xl lg:max-w-4xl"
                    >
                        <div class="text-right text-white">
                            <button class="p-2 hover:underline focus:underline" @click.prevent="$emit('close')">
                                {{ $t('Close') }}
                            </button>
                        </div>

                        <div class="rounded-lg bg-white px-4 pt-5 pb-4 shadow-xl sm:p-10">
                            <slot></slot>
                        </div>
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup>
    import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';

    const props = defineProps({
        show: Boolean,
    });
</script>
